export const emptyFunction = () => {
  // Silence is golden
};

export default emptyFunction;
